var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsLinkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_41001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 17.6343C35.5 7.96929 27.665 0.134277 18 0.134277C8.33502 0.134277 0.5 7.96929 0.5 17.6343C0.5 27.2993 8.33502 35.1343 18 35.1343C27.665 35.1343 35.5 27.2993 35.5 17.6343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8327 13.6343H21.9577C24.3739 13.6343 26.3327 15.593 26.3327 18.0093C26.3327 20.4255 24.3739 22.3843 21.9577 22.3843H12.5827C10.9719 22.3843 9.66602 21.0784 9.66602 19.4676C9.66602 17.8568 10.9719 16.5509 12.5827 16.5509H21.9577C22.7631 16.5509 23.416 17.2039 23.416 18.0093C23.416 18.8147 22.7631 19.4676 21.9577 19.4676H13.8327",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.634277,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#A2A2A2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_41001"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.134277,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsLinkCircle);
export default __webpack_public_path__ + "static/media/sns_link_circle.05017d77b7fa29db30efc0d222cef611.svg";
export { ForwardRef as ReactComponent };